import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Roles, UUID } from "../models";
import { Resource } from "../types";

export enum DialogMode {
  OpenForEdit = "OPEN_FOR_EDIT",
  Closed = "CLOSED"
}

export interface ImageManagementBulkImageState {
  readonly mode: DialogMode;
  readonly availableRoles: Resource<Roles>;
  readonly selectedRole: UUID | null;
}

export const initialState: ImageManagementBulkImageState = {
  mode: DialogMode.Closed,
  availableRoles: { isPending: false },
  selectedRole: null
};

// thunks
export const openImageManagementBulkImageDialog = createAsyncThunk(
  "imageManagementBulkImageDialog/openImageManagementBulkImageDialog",
  (_: void, thunkApi) => {
    const { dispatch } = thunkApi;
    dispatch(setOpenImageManagementBulkImageDialog());
  }
);

export const imageManagementBulkImageDialog = createSlice({
  name: "imageManagementBulkImageDialog",
  initialState: initialState,
  reducers: {
    setOpenImageManagementBulkImageDialog: () => {
      return {
        ...initialState,
        mode: DialogMode.OpenForEdit
      };
    },
    closeImageManagementBulkImageDialog: state => {
      state.mode = DialogMode.Closed;
    },
    setSelectedRole: (state, action: PayloadAction<UUID>) => {
      state.selectedRole = action.payload;
    }
  }
});

export const {
  setOpenImageManagementBulkImageDialog,
  closeImageManagementBulkImageDialog,
  setSelectedRole
} = imageManagementBulkImageDialog.actions;

export default imageManagementBulkImageDialog.reducer;
